import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  
} from '@mui/material';
import colors from '../theme/Colors';
import CustomSelect from './CustomSelect';
const InventoryShareDialog = ({
  open,
  handleClose,
  selectedCustomer,
  setSelectedCustomer,
  customers,
  previewImage,
  handleShare
}) => {
  return (
    <Dialog 
      open={open} 
      onClose={() => {
        handleClose();
        setSelectedCustomer('');
      }}
      maxWidth="md"
      fullWidth
    >
      <DialogTitle>Share Inventory</DialogTitle>
      <DialogContent>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 2 }}>
          <CustomSelect
            label="Select Customer"
            value={selectedCustomer}
            onChange={(e) => setSelectedCustomer(e.target.value)}
            options={customers.map((c) => ({ id: c._id, name: c.name }))}
            sx={{ minWidth: 250 }}
          />
          {previewImage && (
            <Box sx={{ mt: 2, overflow: 'auto', maxHeight: '60vh' }}>
              <Typography variant="subtitle1" gutterBottom>
                Preview:
              </Typography>
              <img 
                src={previewImage} 
                alt="Table Preview" 
                style={{ 
                  width: '100%',
                  height: 'auto',
                  border: '1px solid #ddd',
                  borderRadius: 4
                }} 
              />
            </Box>
          )}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button 
          onClick={() => {
            handleClose();
            setSelectedCustomer('');
          }}
        >
          Cancel
        </Button>
        <Button
          onClick={handleShare}
          variant="contained"
          disabled={!selectedCustomer || !previewImage}
          sx={{
            backgroundColor: colors.primary,
            color: 'black',
            '&:hover': {
              backgroundColor: colors.primary,
              opacity: 0.9
            }
          }}
        >
          Share
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default InventoryShareDialog;
